module.exports = __webpack_public_path__ + "img/page-img.4997bbf0.jpg";